import { render, staticRenderFns } from "./VisitasDomiciliares.vue?vue&type=template&id=1f95ab1e"
import script from "./VisitasDomiciliares.vue?vue&type=script&lang=js"
export * from "./VisitasDomiciliares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports